(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceItemCopyV2Controller', ServiceItemCopyV2Controller);

    ServiceItemCopyV2Controller.$inject = ['$uibModalInstance', 'entity', 'ServiceItemCustom'];

    function ServiceItemCopyV2Controller($uibModalInstance, entity, ServiceItemCustom) {
        var vm = this;


        vm.serviceItem = entity;
        vm.clear = clear;
        vm.copyServiceItem = copyServiceItem;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function copyServiceItem(serviceItemId) {
            ServiceItemCustom.createCopyOfServiceItemById(serviceItemId).query(function (res) {
                // vm.loadPage();
                $uibModalInstance.close(true);
            });
        }

    }
})();
